import { render, staticRenderFns } from "./icon-more-vertical.vue?vue&type=template&id=518e8b84&"
import script from "./icon-more-vertical.vue?vue&type=script&lang=js&"
export * from "./icon-more-vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports